var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"appendix",attrs:{"id":"appendix"}},[_c('h2',{staticClass:"theme-background"},[_vm._v(_vm._s(_vm.ARTICLE.defaultlang=='zh'?'附录':'Appendix'))]),_vm._v(" "),_vm._l((_vm.appendix),function(item){return _c('jo' + item.name,{key:item.index,tag:"component",attrs:{"data":item.data}})})],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2173b730","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/componentsMobile/maincontent/body/appendix/appendix.vue
// module id = null
// module chunks = 